<template>
    <ModalComponent
        name="addAbonado"
        title="Añadir nuevo abonado"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" class="row" @submit.prevent="submit">
            <div class="col-12">
                <FormInput label="Nombre" name="name" rules="required" v-model="data.name" />
            </div>
            <div class="col-12">
                <FormInput label="Apellidos" name="surnames" rules="required" v-model="data.surnames" />
            </div>
             <div class="col-12">
                <div class="form-group">
                    <label for="genero">Género</label>
                    <ValidationProvider name="genero" rules="required" v-slot="{ errors }">
                        <select type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Género" v-model="data.genero_id">
                            <template v-for="genero in generos">
                                <option :key="genero.id" :value="genero.id">{{ genero.name }}</option>
                            </template>
                        </select>
                        <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12">
                <FormInput label="Dni" name="dni" rules="required" v-model="data.dni" />
            </div>
            <div v-if="mostrar_iban == true" class="col-12">
                <div class="form-group">
                    <label for="dni">IBAN</label>
                    <ValidationProvider name="iban" rules="required" v-slot="{ errors }">
                        <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="IBAN" v-model="data.iban">
                        <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div v-if="mostrar_titular_cuenta == true" class="col-12">
                <div class="form-group">
                    <label for="dni">Titular de la cuenta</label>
                    <ValidationProvider name="iban" rules="required" v-slot="{ errors }">
                        <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Titular de la cuenta" v-model="data.titular_cuenta">
                        <span v-if="errors[0]" id="exampleInputTitularCuenta1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12">
                <FormInput label="Nº de abonado" name="n_abonado" rules="required" v-model="data.n_abonado" />
            </div>
            <div class="col-12">
                <FormInput label="Nº de abonado antiguo" name="n_abonado_antiguo" rules="required" v-model="data.n_abonado_antiguo" />
            </div>
            <div class="col-12" v-if="error">
                <div class="alert alert-danger" role="alert">
                    {{ error }}
                </div>
            </div>
            <div class="col-12 mt-3">
                <Button id="submit-add-abonado" type="submit" :disabled="loading">Añadir</Button>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import Generos from "@/mixins/Generos";

    export default {
        mixins: [Generos],
        data() {
            return {
                data: {},
                loading: false,
                error: null,
                mostrar_iban: this.$store.getters.getTeatro.mostrar_iban,
                mostrar_titular_cuenta: this.$store.getters.getTeatro.mostrar_titular_cuenta
            }
        },
        created() {
            this.getGeneros();
        },
        methods: {
            close(actualizar) {
                this.$emit('close', 'addAbonado', actualizar);
            },
            crear() {
                this.loading = true;

                this.data.filters = {};

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.create'), this.data).then(res => {
                    this.loading = false;
                    this.$toast.success("Abonado creado correctamente");
                    this.close(true);
                }).catch(error => {
                    this.error = error.response.data.message;
                    this.loading = false;
                });
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crear();
                }
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
